export default "__VITE_ASSET__2aa94733__"